<div class="card-holder card">
  <!-- <div class="head-text">
    Your Team Store in 3 simple steps!
  </div> -->
  <div class="header">
    <a class="back-button" (click)="goBack()"
      *ngIf="filterServ.selectedStepIndex==0 || filterServ.selectedStepIndex==3  ">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="19" y1="12" x2="5" y2="12"></line>
        <polyline points="12 19 5 12 12 5"></polyline>
      </svg>
      <span>Back</span>
    </a>
  </div>
  <mat-horizontal-stepper class="step-margin" labelPosition="bottom" [linear]="true" #stepper
    (selectionChange)="onStepChange(stepper)">


    <mat-step label="Select Team" [completed]="storeTeamForm.valid">
      <div class="m-2 row d-flex justify-content-center" style="padding-bottom: 1rem;">
        <div class="sub-head">
          Store Info
        </div>
      </div>
      <div>

        <div class="mb-4 pb-4">
          <app-first-form [storeTeamForm]="storeTeamForm" [states]="states"
            [selectedOrganization]="selectedOrganization" [markets]="productGroups" [organizationArray]="organizationArray"
            [searchText]="searchText" [searchTextMark]="searchTextMark" (nextEvent)="mapNext($event)"
            (emailSelect)="onEmailChange()" (organizationSelect)="onOrganizationSelect()"
            (marketSelect)="onMarketSelect()"></app-first-form>
        </div>
      </div>
    </mat-step>
    <mat-step [completed]="filterServ.selectedProductList.length > 0">

      <div class="confirmation-container">
        <div class="confirmation-content">
          <p class="description">
            The products shown below are exactly how they will appear in your live store. <br />
            Our team carefully selected these fan-favorite items to help your supporters show their team pride in style.
          </p>

          <div class="question">
            ✅ <strong>Happy with how it looks?</strong>
          </div>

          <div class="instructions">
            <p><strong>Click the “Proceed to Launch” button below, and your store will be ready to go!</strong></p>
            <p>🛠️ Want to make some changes?</p>
            <p>Click “Change Products” to customize your selection before launching.</p>
          </div>

          <div class="action-buttons">
            <button class="btn btn-secondary" matStepperPrevious>Back To Store Info</button>
            <button class="btn btn-primary" [disabled]="filterServ.selectedProductList.length == 0"
              (click)="statusChanged('launch');saveStore(stepper)">Proceed To Launch</button>
          </div>

          <div class="save-draft">
            <span>Not Ready To Launch? <a [class.disabled]="filterServ.selectedProductList.length == 0" (click)="statusChanged('draft');saveStore(stepper)">Save To
                Drafts</a></span>
          </div>
        </div>
      </div>

      <ng-template matStepLabel>
        <div>
          Preview Store
        </div>
      </ng-template>
      <div class="m-2">
        <!-- <div class="sub-head">
          Edit Store
        </div> -->

        <mat-tab-group #tabGroup (selectedTabChange)="onTabChange($event)">
          <mat-tab>
            <ng-template mat-tab-label>
              Store Preview
              <!-- <span class="stylen">{{filterServ.selectedProductList.length}}</span> -->
            </ng-template>


            <div class="store-title" *ngIf="filterServ.editStoreTab ==0">
              <ng-container *ngIf="!isEditing; else editTemplate">
                <h2>
                  <strong>{{ storeName }}</strong>
                  <button mat-icon-button class="edit-icon" (click)="isEditing = true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="icon icon-tabler icons-tabler-outline icon-tabler-edit">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                      <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                      <path d="M16 5l3 3" />
                    </svg>
                  </button>
                </h2>
              </ng-container>

              <ng-template #editTemplate>
                <div class="edit-container">
                  <input type="text" [(ngModel)]="storeName" class="edit-input" />
                  <button class="btn btn-primary" (click)="updateStoreName()">Update</button>
                  <button class="btn btn-light" (click)="cancelEdit()">Cancel</button>
                </div>
              </ng-template>
            </div>

            <app-edit-product [currentTab]="filterServ.editStoreTab"
              [selectedProductList]="filterServ.selectedProductList" [productList]="filterServ.selectedProductList"
              [action]="'Store'"></app-edit-product>

          </mat-tab>
          <mat-tab label="Add Products">

            <div class="category-bar-container" *ngIf="filterServ.editStoreTab == 1">
              <div class="category-tab" *ngFor="let category of categoryList"
                (click)="chooseFilter(category,'categories')" [ngClass]="{'active': category.stat}">
                {{ category.name }}
              </div>
            </div>

            <app-edit-product [currentTab]="filterServ.editStoreTab"
              [selectedProductList]="filterServ.selectedProductList" [productList]="filterServ.productList"
              (checkProduct)="checkProduct($event?.product,$event?.i)"
              (dialogEmit)="openDialog($event?.modStat, $event?.product)" [action]="'Add'"
              (checkColors)="getColor($event)"></app-edit-product>

            <div class="d-flex justify-content-center">
              <mat-paginator #paging class="m-3 mt-0" [length]="filterServ.paginationLength"
                [pageSize]="filterServ.filterParams.per_page" [pageSizeOptions]="pageSizeOptions"
                aria-label="Select page" (page)="pageEvent($event)">
              </mat-paginator>
            </div>
          </mat-tab>

          <mat-tab label="Edit/Remove Products">
            <div class="labels-container">
              <p>Click 'Remove' to remove products from your store</p>
              <p>Click "Designs" buttons to change the design</p>
            </div>
            <app-edit-product [currentTab]="filterServ.editStoreTab"
              [selectedProductList]="filterServ.selectedProductList" [productList]="filterServ.selectedProductList"
              (checkProduct)="checkProduct($event.product,$event.i)"
              (dialogEmit)="openDialog($event.modStat, $event.product)" [action]="'Remove'"
              (checkColors)="getColor($event)"></app-edit-product>
            <div class="d-flex justify-content-center">
            </div>
          </mat-tab>

        </mat-tab-group>


      </div>
      <!-- <div class="d-flex justify-content-center">
        <button class="btn btn-light hov-btn" (click)="openDialog(myDialog)">Advanced Edit Store</button>
      </div> -->
      <!-- <div class="d-flex justify-content-between">
        <button class="btn btn-light" matStepperPrevious>Back</button>
        <button class="btn btn-primary" [disabled]="filterServ.selectedProductList.length == 0" matStepperNext
          (click)="mapNext('second')">Next</button>
      </div> -->
    </mat-step>

    <mat-step label="Launch">
      <!-- <div class="header">
        <a class="back-button" matStepperPrevious>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          <span>Back</span>
        </a>
      </div> -->
      <app-third-form [shippingSelect]="shippingSelect" [storeDetailForm]="storeDetailForm"
        [userSelectedOrganization]="userSelectedOrganization" (submit)="IsValidShipToAddress()"></app-third-form>
      <!-- <div class="row">
        <div class="col-12 d-flex justify-content-center">
          <button class="btn btn-light" matStepperPrevious>Back</button>
          <button class=" btn btn-primary" [disabled]="storeDetailForm.valid"
            (click)="IsValidShipToAddress(stepper)">Launch</button>
          </div>
      </div> -->
    </mat-step>


  </mat-horizontal-stepper>

</div>




<ng-template id="modal-opened-sty" #myDialog let-dialogRef="dialogRef">
  <div mat-dialog-content class="p-5 d-flex justify-content-center">
    <strong>
      <p style="font-size: 1rem;">This option allows you to add/remove products. If you're satisfied with your current
        product list, there's no need to use advanced editing.</p>
    </strong>
  </div>
  <div mat-dialog-actions class="d-flex justify-content-center py-3">
    <button mat-button class="mr-2" (click)="dialogRef.close()">Cancel</button>
    <button class="btn btn-primary" (click)="dialogRef.close('proceed')">Proceed</button>
  </div>
</ng-template>



<div class="modal fade" id="addOrgModal" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <mat-label>Add Organization</mat-label>
        <button type="button" class="close" (click)="closeOrganiztionModal()">
          &times;
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="organizationForm" novalidate class="form-group" id="organizationForm">
          <input type="text" class="form-control m-2" formControlName="name" placeholder="Organization Name" required />
          <input type="text" class="form-control m-2" formControlName="address" placeholder="Address 1" required />
          <input type="text" class="form-control m-2" formControlName="address1" placeholder="Address 2" />
          <input type="text" class="form-control m-2" formControlName="city" placeholder="City" required />
          <select class="form-control m-2" formControlName="state" name="State" required>
            <option value="" disabled selected hidden>State</option>
            <option *ngFor="let item of states" [value]="item.id">
              {{ item.name }}
            </option>
          </select>
          <input type="text" class="form-control m-2" formControlName="zipCode" placeholder="Zip Code" required />
          <button type="button" class="btn btn-primary m-2 float-right" (click)="createNewOrganization()">
            Add Organization
          </button>
        </form>
      </div>
    </div>
  </div>
</div>